import React from 'react'
import { useSelector } from 'react-redux'
import '../../styles/NeoButtonNewDesign.css'
import 'custom/styles/color_variable.css'

function NeoButton({ onClick, text, disabled, type, ref, mode = 'gradient', iconTitle, styles, tabIndex='' }) {
  const neoStyles = {
    solidButton: {
      border: 'none',
      fontSize: '14px',
      width: '100%',
      height: '45px',
      color: 'white',
      fontWeight: '500',
      borderRadius: '20px',
      background: 'linear-gradient(90deg, #FF6300 , #E13060)',
      minWidth:'80px'
    },
    newDesignButton : {
      background: 'var(--primary_1)',
    }
  }

  switch (mode) {
    case 'clear':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          className='btn btn-sm btn-link text-primary small'
          disabled={disabled}
          onClick={onClick}>
          <p >{text}</p>
        </button>
      )
    case 'gradient':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          style={{
            ...neoStyles.solidButton,
            // ...gradientColors,
            ...styles
          }}
          disabled={disabled}
          ref={ref}
          onClick={onClick}>
          <p className='my-auto mx-auto' >
            {text}
          </p>
        </button>
      )
    case 'link':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          className='btn btn-link p-0 small'
          disabled={disabled}
          onClick={onClick}>
          {text}
        </button>
      )
    case 'icon':
      return (
        <button tabIndex={tabIndex} type={type} className='btn p-0' style={styles} onClick={onClick}>
          <i className='material-icons text-darkbluegray cursor-pointer'>{iconTitle}</i>
        </button>
      )
    case 'show':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          style={{
            ...neoStyles.solidButton,
            // ...gradientColors,
          }}
          className='btn-md btn-block btn-neo-show mt-3'
          disabled={disabled}
          onClick={onClick}>
          <p >{text}</p>
        </button>
      )
    case 'vanilla':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          className='btn btn-block button-style'
          disabled={disabled}
          onClick={onClick}>
          <p >{text}</p>
        </button>
      )
    case 'back':
      return (
        <div tabIndex={tabIndex} className='col-1 cursor-pointer' onClick={onClick}>
          <i className='material-icons h1 text-dark'>chevron_left</i>
        </div>
      )
    case 'newDesign':
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          style={{
            ...neoStyles.solidButton,
            ...neoStyles.newDesignButton,
            ...styles
          }}
          className='neo-btn-new-design'
          disabled={disabled}
          ref={ref}
          onClick={onClick}>
          <p className='my-auto mx-auto'>
            {text}
          </p>
        </button>
      )
    default:
      return (
        <button
          tabIndex={tabIndex}
          type={type}
          style={{
            ...neoStyles.solidButton,
            // ...gradientColors,
          }}
          disabled={disabled}
          onClick={onClick}>
          <p >{text}</p>
        </button>
      )
  }
}

export default NeoButton
